import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { Group } from '@era/security-sdk';
import { GroupListItemComponent } from './group-list-item.component';

@Component({
  selector: 'era-group-list-item',
  templateUrl: './group-list-item.container.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [GroupListItemComponent],
})
export class GroupListItemContainerComponent {
  public readonly group = input.required<Group>();
  public readonly isEditing = input(false);
  public readonly isSelected = input(false);

  /** Emits when the user requests to delete a group. Parent should dispatch GroupStoreActions.GroupListItemUIActions.groupDeleteRequested. */
  public readonly deleteRequested = output<Group>();

  deleteEvent(group: Group) {
    this.deleteRequested.emit(group);
  }
}
